// Garçom usa só o app mobile (garcom-app-pedidos). A web bloqueia o acesso dele.
export const WAITER_WEB_BLOCKED_MESSAGE = 'Garçom deve usar o app do garçom. O acesso pela web não é permitido.'

// link do app do garçom na Play Store; sem ele a tela de login só mostra o aviso
const downloadUrl = process.env.REACT_APP_GARCOM_APP_URL || ''
export const WAITER_APP_DOWNLOAD_URL = downloadUrl.startsWith('https://') ? downloadUrl : ''

const BLOCKED_NOTICE_KEY = 'waiter_blocked_notice'

// chaves da sessão gravadas no login e ao longo do uso
const SESSION_KEYS = [
  'access_token',
  'refresh_token',
  'user',
  'isModuleNota',
  'isBotAtendimento',
  'active',
  'message',
  'companyLink',
  'plan',
  'ja_mostro',
  'modal-caixa',
]

export function isWaiter(user) {
  return user?.typeUser === 'garcom'
}

function storedUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')
  } catch (error) {
    return null
  }
}

/**
 * Sessão de garçom aberta antes do bloqueio (token dura 30 dias): apaga a sessão e deixa um aviso para a tela de login.
 * Chamado em src/index.js antes de montar a árvore, porque os providers leem o localStorage na criação.
 * Retorna true quando a sessão foi descartada.
 */
export function dropWaiterSession() {
  if (!isWaiter(storedUser())) {
    return false
  }

  SESSION_KEYS.forEach((key) => localStorage.removeItem(key))
  sessionStorage.setItem(BLOCKED_NOTICE_KEY, '1')
  return true
}

/** Retorna true (uma vez) se a sessão de garçom foi descartada, para a tela de login avisar. */
export function consumeWaiterBlockedNotice() {
  if (!sessionStorage.getItem(BLOCKED_NOTICE_KEY)) {
    return false
  }
  sessionStorage.removeItem(BLOCKED_NOTICE_KEY)
  return true
}
